import { type ImageField } from '@/types/schema/fields';
import { type KnackField } from '@/types/schema/KnackField';
import { type KnackObjectResponse } from '@/types/schema/KnackObject';
import { type ViewWithTableColumn } from '@/components/views/common/table/types';

/**
 * Calculates the default column width for image fields based on their resize format.
 * Returns 150px for web-friendly images or the maxWidth for other resize types.
 * @returns The default width in pixels, or undefined if not an image field or no resize format
 */
export const getImageFieldDefaultColumnWidth = (
  sourceTable: KnackObjectResponse | null,
  viewColumn: ViewWithTableColumn | undefined
) => {
  if (!sourceTable?.fields || !viewColumn?.field?.key) return undefined;

  const isImageField = (field: KnackField): field is ImageField => field.type === 'image';

  const foundField = sourceTable.fields.find((field) => field.key === viewColumn.field?.key);

  const imageField: ImageField | undefined =
    foundField && isImageField(foundField) ? foundField : undefined;

  if (!imageField?.format?.resize) return undefined;

  return imageField.format.resize.type === 'web-friendly' ? 150 : imageField.format.resize.maxWidth;
};
